import axios from 'axios';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useSetInselzuschlagMutation, useCreateHinweisMutation, useGetAnzahlBeiAdresseMutation, useGetHinweiseMutation, useGetHistoriePrivateMutation, useGetTermineMutation, useTerminMutation, useWiedervorlageMutation, useTerminStornoMutation, useUnpinnAuftragMutation, useStorniereAuftragMutation, useGetDeckblattPDFMutation } from '../../api/AuftragAPI';
import { useGetUserProfilesMutation } from '../../api/UserRoleAPI';
import { IAuftrag, IAuftragHinweisResponse, IAuftragHistorie, IAuftragTerminResponse, IOnlyUserProfile } from '../../types/Types';
import { formatToEuroDate, formatToEuroDateTime, formatToStringISODate } from '../../util/DateUtils';
import Styles from './auftragterminierencomponent.module.scss';
import { LoadingModal } from '../LoadingModal/LoadingModal';
import UploadToServer from '../UploadToServer';
import AuftragDeckblattDownloadComponent from '../buttons/AuftragDeckblattDownloadComponent';

export type IAuftragsdaten = {
  stunde: string,
  minute: string,
  wiedervorlagetage: string,
  terminierungFertig: boolean,
  termindatum: string,
}

interface ThisProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  statusChanged: () => void;
  changeColor: (auftraguid: string, color: string) => void;
  centerOnMap: (id: string) => void;
  numberOnMap: number,
  propsAuftrag: IAuftrag,
  googleToken: string | undefined | null,
}

/**
 * @author noone
 */
const AuftragTerminierenComponent: React.FC<ThisProps> = ({ statusChanged, changeColor, centerOnMap, numberOnMap, propsAuftrag, googleToken }) => {

  const [setTerminAPI] = useTerminMutation();
  const [setWiedervorlageAPI] = useWiedervorlageMutation();
  const [getAuftragHistoriePrivate] = useGetHistoriePrivateMutation();
  const [getUserProfiles] = useGetUserProfilesMutation();
  const [getHinweise] = useGetHinweiseMutation();
  const [createHinweis] = useCreateHinweisMutation();
  const [getAuftragTermine] = useGetTermineMutation();
  const [getAnzahlBeiAdresse] = useGetAnzahlBeiAdresseMutation();
  const [setInselzuschlagApi] = useSetInselzuschlagMutation();
  const [terminStornoAPI] = useTerminStornoMutation();
  const [unpinnAuftragAPI] = useUnpinnAuftragMutation();
  const [stornoAuftragAPI] = useStorniereAuftragMutation();

  const [auftrag, setAuftrag] = useState<IAuftrag>(propsAuftrag);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [minute, setMinute] = useState<string>("00");
  const [stunde, setStunde] = useState<string>("00");
  const [wiedervorlageTage, setWiedervorlageTage] = useState<number>(0);
  const [wiedervorlageAm, setWiedervorlageAm] = useState<Date | null>(null);
  const [terminierungFertig, setTerminierungFertig] = useState<boolean>(false);
  const [inselzuschlag, setInselzuschlag] = useState<boolean>(false);
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);
  const [hinweise, setHinweise] = useState<IAuftragHinweisResponse[]>([]);
  const [userProfiles, setUserProfiles] = useState<IOnlyUserProfile[]>([]);
  const [ausfuehrender, setAusfuehrender] = useState<string>();
  const [termindatum, setTermindatum] = useState<string>();
  const [calendarId, setCalendarId] = useState<string>("primary");
  const [termineVonAusfuehrenden, setTermineVonAusfuehrenden] = useState<IAuftragTerminResponse[]>([]);
  const [auftraegeInDerNaehe, setAuftraegeInDerNaehe] = useState<string[]>([]);
  const [hinweisFuerAG, setHinweisFuerAG] = useState<string>("");
  const [hinweisEigene, setHinweisEigene] = useState<string>("");

  const [sichtbar, setSichtbar] = useState(true);
  const [subAnzeige, setSubAnzeige] = useState<string>("info");
  const [color, setColor] = useState<string>(auftrag.colorAuftrag || "#3B3B3B");

  const stornoTermin = (uid: string) => {
    console.log('rueckgaengig ' + uid);
    terminStornoAPI(uid).unwrap()
      .catch((error) => { console.log(error) })
      ;
  }

  const submitWiedervorlage = async (auftrag?: IAuftrag) => {

    if (!auftrag) return;

    var datumInXTagen: Date = new Date();
    datumInXTagen.setDate(new Date().getDate() + wiedervorlageTage);
    await setWiedervorlageAPI({ uid: auftrag.uid, datum: formatToStringISODate(datumInXTagen) })
      .then(() => setWiedervorlageAm(datumInXTagen))
      .then(() => statusChanged())
      .catch((e) => alert("" + e));
  }

  const handleChangeTermindatum = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setTermindatum(e.target.value);
  }

  const speicherHinweiseEigene = async () => {
    if (hinweisEigene !== "") {
      createHinweis({ uid: auftrag.uid, typ: "EIGENE", text: hinweisEigene })
        .then(() => getHinweisListe())
        .then(() => setHinweisEigene(""))
    }
  }

  const speicherHinweiseFuerAG = async () => {
    if (hinweisFuerAG !== "") {
      createHinweis({ uid: auftrag.uid, typ: "AG", text: hinweisFuerAG })
        .then(() => getHinweisListe())
        .then(() => setHinweisFuerAG(""))
    }
  }

  const getHinweisListe = async () => {
    getHinweise(auftrag.uid).unwrap().then((data) => {
      setHinweise(data);
    });
  }

  const submitTerminierung = async (auftrag: IAuftrag) => {

    if (termindatum === undefined) {
      alert("Bitte Datum füllen!");
      return;
    }

    if (stunde === "" || minute === "") {
      alert("Bitte Stunde und Minute auswählen!");
      return;
    }

    if (ausfuehrender === undefined || ausfuehrender === null) {
      alert("Bitte Ausführenden auswählen!");
      return;
    }

    const temptermindatum = termindatum!! + "T" + stunde + ":" + minute + ":00.000Z"

    setIsLoading(true);
    await setTerminAPI({ uid: auftrag.uid, datumuhrzeit: temptermindatum, uidAusfuehrender: ausfuehrender })
      .then(() => setTerminierungFertig(true))
      .then(() => statusChanged())
      .catch((e) => alert("" + e))
      .finally(() => setIsLoading(false));

    try {

      if (googleToken === null || googleToken === undefined) {

        const bisStunde: number = parseInt(stunde, 10) + 1;

        const event = {
          summary: auftrag.art + " bei " + auftrag.name_endkunde + " in " + auftrag.stadt_lieferadresse,
          start: { dateTime: termindatum + "T" + stunde + ":" + minute + ":00-07:00" },
          end: { dateTime: termindatum + "T" + bisStunde + ":" + minute + ":00-07:00" },
        };

        const response = axios.post(
          "https://www.googleapis.com/calendar/v3/calendars/" + calendarId + "/events",
          event,
          {
            headers: {
              Authorization: `Bearer ${googleToken}`,
              "Content-Type": "application/json",
            },
          }
        ).catch(error => console.log(error));
      }
    } catch (error) {
      console.log(error);
    }

  }

  const stornoAuftrag = (uid: string) => {
    stornoAuftragAPI(uid).unwrap()
      .then(() => statusChanged())
      .catch((error) => { console.log(error) })
      ;
  }

  const unpinnAuftrag = async () => {
    unpinnAuftragAPI(auftrag.uid).unwrap()
      .then(() => setAuftrag(prev => ({ ...prev, angepinnt: false })))
      .catch((e) => console.log("" + e));
  }

  useEffect(() => {
    setInselzuschlagApi({ uid_auftrag: auftrag.uid, janein: inselzuschlag }).unwrap()
      .then(() => console.log("Inselzuschlag aufgerufen mit " + inselzuschlag))
      .catch((e) => console.log("" + e));

  }, [inselzuschlag]);

  useEffect(() => {
    let tmpCalendarId = "primary";

    const a = userProfiles.filter(it => it.uid === ausfuehrender);
    if (a.length > 0 && a[0].calendarId !== null)
      tmpCalendarId = a[0].calendarId;

    setCalendarId(tmpCalendarId);

  }, [ausfuehrender]);

  useEffect(() => {
    if (ausfuehrender === undefined || ausfuehrender === null || termindatum === undefined || termindatum === null) return;
    getAuftragTermine({ datum: termindatum, profileUid: ausfuehrender }).unwrap().then((data) => {
      setTermineVonAusfuehrenden(data);
    });

  }, [ausfuehrender, termindatum]);

  useEffect(() => {
    changeColor(auftrag.uid, color);
  }, [color]);

  useEffect(() => {
    getAuftragHistoriePrivate(auftrag.uid).unwrap().then((data) => setHistorie(data));

    getHinweisListe();

    //
    getUserProfiles().unwrap()
      .then(data => {
        setUserProfiles(data);
      });

    //
    getAnzahlBeiAdresse(auftrag.uid).unwrap()
      .then((data) => {
        setAuftraegeInDerNaehe(data);
      });

  }, []);

  return (
    <>

      <LoadingModal show={isLoading} />

      {sichtbar && (
        <div className={Styles.auftragCardWrapper} id={"number" + numberOnMap + "Auftrag"}>

          <div className={Styles.auftragCardHeader} >

            <div onClick={() => document.getElementById("colorinput_" + numberOnMap)?.click()} className={Styles.badge} style={{ background: (color.length === 7) ? color : "#" + color, color: "white" }}>{numberOnMap}</div>

            <input
              id={"colorinput_" + numberOnMap}
              type="color"
              value={(color.length === 7) ? color : "#" + color}
              onChange={(e) => setColor(e.target.value)}
              style={{ visibility: "hidden", position: "absolute" }}
            />

            {auftrag?.angepinnt &&
              <div>
                <i onClick={() => { unpinnAuftrag() }} style={{ color: "black", fontSize: "2rem" }} className="bi bi-pin-fill"></i>
              </div>
            }

            <div className={Styles.info}>
              <div className={Styles.title}>{auftrag?.art}</div>
              <div className={Styles.date}>erstellt am {formatToEuroDateTime(auftrag.createDate)}</div>
            </div>


            <div className={Styles.actions}>
              <button
                className="btn"
                onClick={(event: FormEvent) => {
                  event.stopPropagation();
                  centerOnMap(auftrag.uid);
                }} ><i className='bi bi-geo-alt'></i></button>
              <button
                className="btn"
                onClick={(event: FormEvent) => {
                  event.stopPropagation();
                  window.open(
                    "./.auftragdetails?uid=" + auftrag?.uid + "&backbuttonClose=true",
                    "_blank"
                  );
                }} ><i className='bi bi-pencil-fill'></i></button>

            </div>
          </div>

          <div className={Styles.auftragCardContent}>
            <div>

              <AuftragDeckblattDownloadComponent uidAuftrag={auftrag.uid} />

              <div className="card" style={{ marginTop: "1em", padding: "1em" }}>
                <br />{auftrag?.vorname_endkunde} {auftrag?.name_endkunde}
                <br />{auftrag?.strasse_lieferadresse} {auftrag?.hausnummer_lieferadresse}
                <br />{auftrag?.postleitzahl_lieferadresse}  {auftrag?.stadt_lieferadresse}

                <p>
                  <br />Nr. Aufträge hier: <span style={{ backgroundColor: (auftraegeInDerNaehe.length !== 1) ? "red" : "white", border: "1px solid black", padding: "3pt", borderRadius: "5px" }}>{auftraegeInDerNaehe.length}</span>
                  <br />Mobil1: {auftrag?.mobil1_lieferadresse}
                  <br />Mobil2: {auftrag?.mobil2_lieferadresse}
                  <br />Telefon: {auftrag?.telefon_lieferadresse}
                  <br />Email: {auftrag?.email_lieferadresse}
                </p>

                <p>Besonderheiten: {auftrag?.besonderheiten} </p>

              </div>
            </div>
            <div>

              {(terminierungFertig === true &&
                <>
                  <span>
                    Fertig terminiert für {termindatum}
                    <button className="btn btn-danger"><i className="bi bi-trash" onClick={(e) => stornoTermin(auftrag.uid)}></i>&nbsp;Rückgängig</button>
                  </span>
                </>)}

              {(wiedervorlageAm !== null &&
                <>
                  <span>Auf wiedervorlage am : {formatToStringISODate(wiedervorlageAm)}</span>
                </>)}

              {(terminierungFertig === false && wiedervorlageAm === null &&
                <>

                  <ul className="nav nav-pills">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a className={`nav-link ${subAnzeige === "info" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("info")}>Info</a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a className={`nav-link ${subAnzeige === "hinweise" ? "active" : ""}`} onClick={() => setSubAnzeige("hinweise")}>Hinweise</a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a className={`nav-link ${subAnzeige === "aktion" ? "active" : ""}`} aria-current="page" onClick={() => setSubAnzeige("aktion")}>Aktion</a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a className={`nav-link ${subAnzeige === "historie" ? "active" : ""}`} onClick={() => setSubAnzeige("historie")} >Historie</a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a className={`nav-link ${subAnzeige === "dateien" ? "active" : ""}`} onClick={() => setSubAnzeige("dateien")} >Dateien</a>
                    </li>
                  </ul>

                  {subAnzeige === "info" &&
                    <div className="card" style={{ marginTop: "1em", padding: "1em" }}>
                      Erstellt am: {formatToEuroDateTime(auftrag.createDate)}<br />
                      Erstellt von: {auftrag?.erstelltVon.name}<br />
                      Auftraggeber: {auftrag?.auftraggeber.name}<br />
                      Spätmögl. Termin: {formatToEuroDate(auftrag?.spaetmesstermin)} <br />
                      {(auftrag?.email_lieferadresse) ? <span>Email an Lieferadresse: <a href={`mailto:${auftrag?.email_lieferadresse ?? ''}`}>{auftrag?.email_lieferadresse}</a></span> : <span>Keine Lieferadressenemail vorhanden</span>}
                      {(auftrag?.email_ansprechpartner) ? <span>Email an Ansprechpartner: <a href={`mailto:${auftrag?.email_ansprechpartner ?? ''}`}>{auftrag?.email_ansprechpartner}</a></span> : <span>Keine Ansprechpartneremail vorhanden</span>}
                    </div>}

                  {subAnzeige === "aktion" &&
                    <>
                      <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

                        <form onSubmit={(e) => { e.preventDefault(); submitWiedervorlage(auftrag); }}>

                          <div className="input-group">
                            <select className="" name="wiedervorlage" value={wiedervorlageTage ?? ""} onChange={(e) => { e.preventDefault(); setWiedervorlageTage(Number.parseInt(e.target.value)) }}>
                              <option value="1">1 Tag</option>
                              <option value="2">2 Tage</option>
                              <option value="7">1 Woche</option>
                              <option value="14">2 Wochen</option>
                              <option value="28">4 Wochen</option>
                              <option value="56">8 Wochen</option>
                            </select>
                            <input type="submit" className='btn btn-warning' value="Wiedervorlage setzen" />
                          </div>
                        </form>

                        <form style={{ marginTop: "2em" }} onSubmit={(e) => { e.preventDefault(); submitTerminierung(auftrag); }}>

                          <div className="input-group mb-3">
                            <label className="input-group-text" htmlFor="selectAusfuehrender">Ausführender:</label>
                            <select name="selectAusfuehrender" id="selectAusfuehrender" value={ausfuehrender} onChange={(e) => { setAusfuehrender(e.target.value) }} >
                              <option value={""}>--- Bitte auswählen ---</option>
                              {userProfiles.map((user, index) => {
                                return <option key={index} value={user.uid}>{user.name}</option>;
                              })}
                            </select>
                          </div>


                          <div className="input-group mb-3">
                            <label className="input-group-text">Datum:</label>
                            <input type="date" style={{ width: "auto", minWidth: "200px" }} name="termindatum" value={termindatum} onChange={handleChangeTermindatum} ></input>
                          </div>

                          {ausfuehrender !== undefined && ausfuehrender !== null && termindatum !== undefined && termindatum !== null &&
                            <>
                              <div>
                                <span>Termine ({termineVonAusfuehrenden.length}):</span>
                                {termineVonAusfuehrenden.map((e, index) => {
                                  return <div key={index}>{formatToEuroDateTime(e.datum)} {e.ort}</div>
                                })}
                              </div>
                            </>}

                          <div className="input-group mb-3">
                            <label className="input-group-text">Uhrzeit:</label>
                            <select name="stunde" value={stunde ?? ""} onChange={(e) => { e.preventDefault(); setStunde(e.target.value) }}>
                              <option value="00">00</option>
                              <option value="01">01</option>
                              <option value="02">02</option>
                              <option value="03">03</option>
                              <option value="04">04</option>
                              <option value="05">05</option>
                              <option value="06">06</option>
                              <option value="07">07</option>
                              <option value="08">08</option>
                              <option value="09">09</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                            </select>
                            <label className="input-group-text">:</label>
                            <select name="minute" value={minute ?? ""} onChange={(e) => { e.preventDefault(); setMinute(e.target.value) }}>
                              <option>00</option>
                              <option>15</option>
                              <option>30</option>
                              <option>45</option>
                            </select>
                          </div>

                          <div className="input-group mb-3" style={{ marginTop: "1em" }}>
                            <div className={(inselzuschlag) ? "btn btn-light" : "btn btn-success"} onClick={() => setInselzuschlag(false)}>Ohne Inselzusatz</div>
                            <div className={(!inselzuschlag) ? "btn btn-light" : "btn btn-success"} onClick={() => setInselzuschlag(true)}>Mit Inselzusatz</div>
                          </div>

                          <input disabled={!ausfuehrender || !termindatum} type="submit" className='btn btn-primary' value="Termin speichern" />
                        </form>

                        <button
                          className="btn btn-danger"
                          onClick={() => { if (window.confirm('Bist du sicher?')) { stornoAuftrag(auftrag.uid); } }} ><i className='bi bi-trash'></i> Stornieren</button>
                      </div>
                    </>}

                  {subAnzeige === "hinweise" &&
                    <>
                      <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

                        <form onSubmit={(e) => { e.preventDefault(); speicherHinweiseFuerAG(); }}>
                          <div>Hinweis für Auftraggeber <textarea style={{ width: "100%" }} rows={5} value={hinweisFuerAG} onChange={(e) => setHinweisFuerAG(e.target.value)} ></textarea></div>
                          <button type="submit" className="btn btn-primary">Speichern</button>
                        </form>

                        <form onSubmit={(e) => { e.preventDefault(); speicherHinweiseEigene(); }}>
                          <div>Hinweis für uns <textarea style={{ width: "100%" }} rows={5} value={hinweisEigene} onChange={(e) => setHinweisEigene(e.target.value)} /></div>
                          <button type="submit" className="btn btn-primary">Speichern</button>
                        </form>

                        {hinweise?.map((e, index) => <>
                          <div key={e.uid}>{formatToEuroDateTime(e.erstelltAm)} {e.erstelltVon} {e.typ} {e.text}</div>
                        </>)}
                      </div>
                    </>}

                  {subAnzeige === "historie" &&
                    <>
                      <div className="card" style={{ marginTop: "1em", padding: "1em" }}>

                        Historie

                        <ul>
                          {historie?.map((e, index) =>
                            <li key={index}>{(e.datum !== null) ? formatToEuroDateTime(e.datum) : "--"} {e.text!!}</li>
                          )}
                        </ul>
                      </div>
                    </>}
                </>)}

              {subAnzeige === "dateien" &&
                <>
                  <div>
                    <h4>Dateien</h4>
                    <UploadToServer uid={auftrag?.uid ?? ''} />
                  </div>
                </>}

            </div>
          </div>


        </div>
      )}
    </>
  );

}

export default AuftragTerminierenComponent;